import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { NavItem, Nav, NavDropdown } from 'react-bootstrap';
import cns from 'classnames';

import NavItemNoIcon from './NavItemNoIcon';
import CaptureClicksV2 from '../../components/CaptureClicksV2';
import Image from '../../../shared/components/Image';
import { generateNumberFromString } from '../../../shared/utils/NumberUtils';

const TeamsDropdown = (props) => {
    const { teamsSortedByJoinedDate, groupPageActive, pathName, teamsLabel = 'groups', handleNavigation } = props;
    const navTitle =
        teamsSortedByJoinedDate.length === 1 && teamsSortedByJoinedDate.length !== 0
            ? teamsSortedByJoinedDate[0].name
            : teamsLabel;
    const [teamList, setTeamList] = useState([]);

    const getImage = (userTeam) => {
        if (userTeam.thumbnailImageUrl) {
            return (
                <div className={'group-dropdown-image-border'}>
                    <Image
                        className={cns('group-dropdown-image')}
                        src={userTeam.thumbnailImageUrl}
                        cloudinaryCrop={'fill'}
                    />
                </div>
            );
        }

        return (
            <div
                className={cns(
                    `col-1 group-dropdown-image-border avatar-color-${generateNumberFromString(userTeam._id, 13)}`
                )}
            >
                <span>{userTeam.name && userTeam.name.slice(0, 2).toUpperCase()}</span>
            </div>
        );
    };

    useEffect(() => {
        const builtList = teamsSortedByJoinedDate.slice(0, 4).map((userTeam, index) => (
            <div className={'row group-dropdown-list-item'} key={index} onClick={() => handleNavigation(`/teams/${userTeam._id}`)}>
                {getImage(userTeam)}
                <Nav.Link
                    eventKey={`user-team-${index}`}
                    active={pathName.includes(userTeam._id)}
                    bsPrefix={'col-10 nav-link'}
                >
                    {userTeam.name}
                </Nav.Link>
            </div>
        ));
        setTeamList(builtList);
    }, [teamsSortedByJoinedDate]);

    if (!teamsSortedByJoinedDate || teamsSortedByJoinedDate.length === 0) {
        return '';
    }
    if (teamsSortedByJoinedDate.length === 1) {
        return (
            <NavItem key={'solo-group'} onClick={() => handleNavigation(`/teams/${teamsSortedByJoinedDate[0]._id}`)} className={cns('navbar-section navbar-groups', { selected: groupPageActive })}>
                <Nav.Link eventKey={1} >
                    <CaptureClicksV2>
                        <NavItemNoIcon
                            customClass={'group-name'}
                            key={'groupsIcon'}
                            textId={'GROUP'}
                            defaultMessage={`${teamsSortedByJoinedDate[0].name?.toUpperCase()}`}
                            isSelected={groupPageActive}
                        />
                    </CaptureClicksV2>
                </Nav.Link>
            </NavItem>
        );
    }

    return (
        <NavDropdown
            title={navTitle.toUpperCase()}
            id={'nav-dropdown'}
            className={cns('navbar-section navbar-dropdown-default navbar-groups row', { selected: groupPageActive })}
        >
            <NavDropdown.Header>RECENT {teamsLabel.toUpperCase()}</NavDropdown.Header>
            {teamList}
            <NavDropdown.Divider />
            <div onClick={() => handleNavigation(`/grouplist`)}>
                <Nav.Link>
                    Go to all {teamsLabel.charAt(0).toUpperCase() + teamsLabel.slice(1)} ({teamsSortedByJoinedDate.length})
                </Nav.Link>
            </div>
        </NavDropdown>
    );
};

TeamsDropdown.propTypes = {
    teamsSortedByJoinedDate: PropTypes.array,
    groupPageActive: PropTypes.bool,
    pathName: PropTypes.string,
    teamsLabel: PropTypes.string
};

export default TeamsDropdown;
